export default __webpack_public_path__ + "static/media/metamask.e0b98e72.webp";